module.exports = __webpack_public_path__ + "img/biaoti.0872b5c2.png";